import { render, staticRenderFns } from "./CheckMark.vue?vue&type=template&id=c70febf8&scoped=true&"
import script from "./CheckMark.vue?vue&type=script&lang=js&"
export * from "./CheckMark.vue?vue&type=script&lang=js&"
import style0 from "./CheckMark.vue?vue&type=style&index=0&id=c70febf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70febf8",
  null
  
)

export default component.exports